async function fetchProductData(handle) {
    const url = window.Shopify.routes.root + 'products/' + handle + '.js';
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch product data for ${handle}`);
        }
        const product = await response.json();
        return product;
    } catch (error) {
        console.error('Error fetching product data:', error);
        throw error;
    }
}

function generateProductCard(productData) {
    const image_url = productData.featured_image.replace('.jpg', '_400x.jpg').replace('.png', '_400x.png');
    const price = productData.price / 100;
    const compare_at_price = productData.compare_at_price / 100;
    const isOnSale = compare_at_price > price;
    const discount_rate = isOnSale ? Math.round((compare_at_price - price) * 100.0 / compare_at_price) : '';
    const sale_badge = isOnSale ? '<span class="sale-badge">SALE</span>' : '';
    const compare_at_price_render = isOnSale ? `<s>${compare_at_price.toLocaleString()}<small>円</small></s>` : '';
    const product_card = `
    <div class="product-card">
        <figure class="product-card-image">
            <a href="${productData.url}" class="image-link">
                <img src="${image_url}" width="200" height="200" loading="lazy">
            </a>
        </figure>
        <h3 class="product-card-title">
            ${sale_badge}<a href="${productData.url}" class="title-link">${productData.title}</a>
        </h3>
        <p class="product-card-vendor"><small>${productData.vendor}</small></p>
        <p class="product-card-rate"><span>${discount_rate}%OFF</span></p>
        <p class="product-card-price">
            <span class="regular-price"><strong>${price.toLocaleString()}</strong><small>円/税込</small></span>${compare_at_price_render}
        </p>
    </div>
    `;
    return product_card;
}

const shortcodeSelectors = ['.sc-product', '.sc-collection'];

shortcodeSelectors.forEach(async (selector) => {
    const shortcodes = document.querySelectorAll(selector);

    for (const code of shortcodes) {
        const data_handle = code.getAttribute('data-handle');
        const handles = data_handle.split(',');

        const productCards = [];

        if (selector === '.sc-collection') {
            try {
                const handle = code.getAttribute('data-handle');
                const response = await fetch(window.Shopify.routes.root + 'collections/' + handle + '/products.json');
                if (!response.ok) {
                    throw new Error(`Failed to fetch collection products for ${handle}`);
                }
                const responseData = await response.json();
                const products = responseData.products;

                if (!products || products.length === 0) {
                    throw new Error(`No products found for collection ${handle}`);
                }

                const dataItems = code.getAttribute('data-items');
                const limit = dataItems ? parseInt(dataItems, 10) : 4;
                const slice_products = products.slice(0, limit);
                if ( limit >= 5 ) {
                    code.classList.add("grid-layout");
                }

                for (const product of slice_products) {
                    const productData = await fetchProductData(product.handle);
                    const productCard = generateProductCard(productData);
                    productCards.push(productCard);
                }
            } catch (error) {
                console.error('Error fetching and rendering collection:', error);
            }
        } else {
            const items = handles.length;
            code.setAttribute('data-items', items);
            if ( items >= 5 ) {
                code.classList.add("grid-layout");
            }
            for (const handle of handles) {
                try {
                    const productData = await fetchProductData(handle);
                    const productCard = generateProductCard(productData);

                    productCards.push(productCard);
                } catch (error) {
                    console.error('Error fetching and rendering product:', error);
                }
            }
        }

        code.innerHTML = productCards.join('');
    }
});
